<template lang="pug">
  include ./../../../../mixins
  validation-observer(
    ref="observer"
    tag="form"
    class="form"
  )
    +b.ug-row--apearance_spaced.--space_md.--align_end-mac
      +b.ug-cell.ug-cols--12.--6-mac
        +b.control-cabinet
          +e.label E-mail
          +e.element--centered {{ formData.email || 'E-mail'}}
      +b.ug-cell.ug-cols--12.--6-md.--3-mac
        toggle-mixin-modal(
          component-name="EmailChange"
        )
          template(
            #default="{ handler }"
          )
            +b.button--height_xl.BUTTON-BEMTO(
              @event="handler"
            ) CHANGE EMAIL
      +b.ug-cell.ug-cols--12.--6-md.--3-mac
        +b.button--height_xl.BUTTON-BEMTO(
          :disabled="isRequest"
          @event="sendTestEmailAPI()"
        )
          +e.load.IMG(
            src="/static/load.gif"
            v-if="isRequest"
          )
          +e.text(
            v-if="!isRequest"
          ) SEND TEST EMAIL
</template>

<script>
import ToggleModalMixin from '@/js/mixins/ToggleModalMixin'
import { getTestEmailAPI } from '@/js/services/cabinet'
import { mapGetters } from 'vuex'

export default {
  name: 'EmailPanel',
  mixins: [
    ToggleModalMixin,
  ],
  data() {
    return {
      /**
       * Component state.
       */
      formData: {
        email: null,
      },
      isRequest: false,
    }
  },
  computed: {
    ...mapGetters('cabinet', [
      'emailCommon',
    ]),
  },
  watch: {
    /**
     * Hook with updating personal
     * data, listening to the data,
     * if any, then we react.
     */
    emailCommon: {
      immediate: true,
      deep: true,
      handler(data) {
        /**
         * If any, then we react.
         */
        if (data) {
          this.prefillData(data)
        }
      },
    },
  },
  methods: {
    /**
     * Sending a test email to the API.
     */
    sendTestEmailAPI() {
      const EMAIL = this.formData

      /**
       * Start request.
       */
      this.isRequest = true

      return getTestEmailAPI.execute(
        EMAIL
      )
        .then(response => {
          const OPTIONS = {
            title: response.data.item.message.message
          }
          /**
           * Show success message.
           */
          this.toggleModalMixin(
            'SuccessCommon', OPTIONS
          )
          /**
           * End request.
           */
          this.isRequest = false
        })
    },
    /**
     * Pre-filling keys with personal
     * user data.
     */
    prefillData(data) {
      Object.keys(data).forEach(key => {
        this.formData[key] = data[key]
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Forms/cabinets/panels/EmailPanel.vue